import 'expose-loader?$!expose-loader?jQuery!jquery'
import 'bootstrap'

import 'jquery-slimscroll'

import 'admin-lte'

// import 'bootstrap3-wysihtml5-bower/dist/amd/bootstrap3-wysihtml5.all.js'



// WEBPACK FOOTER //
// ./src/lib/script.js